module.exports = __webpack_public_path__ + "img/xw.4fc92fd8.jpg";